module.exports = __webpack_public_path__ + "img/fab.cc326f4.svg";